module.exports = __webpack_public_path__ + "img/pinterest-social-icon.8d037336.svg";